import {STEPPER} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function agencyAddConfig() {
    let generalInputs = [
        {
            type: 'text',
            label: 'Nom',
            helper: {
                text: 'Indiquez le nom',
                link: false,
            },
            required: true,
            stateName: 'name',
        },
    ]
    let children = [
        {
            labelName: 'Paramètres',
            isOptionnal: false,
            optionsInputs: generalInputs
        },
    ];

    var obj = {
        titleForm: 'Ajouter un élément',
        subTitleForm: 'Veuillez compléter les champs ci-dessous',
        langSelect: false,
        drawerType: 'drawer',
        noForm: true,
        component: Button,
        formConfig: {
            type: STEPPER,
            finalStep: {
                title: 'Et voilà !',
                subtitle: 'Votre élément est désormais configuré',
                textButton: 'Créer ce pôle'
            },
            children
        }
    };
    return obj;
}